/**
 * 操练场输入分流：文字咨询走 chat-stream，明确的图片生成/编辑走 generations。
 * 规则宁可保守，误判会触发不必要的图片任务和扣费。
 */
export function isImageGenerationRequest(value, hasUploads = false) {
  const text = String(value || '').trim().toLowerCase()
  if (!text || /(?:如何|怎么|怎样).{0,8}(?:生成|制作|设计|画)|(?:生成|绘图|海报).{0,8}(?:教程|方法|提示词)/.test(text)) return false
  const creationVerb = /生成|画一?[张幅个]?|绘制|设计一?[张幅个]?|制作一?[张幅个]?|做一张|出一张|创建|generate|create|draw|design|make/
  const visualObject = /图片|图像|海报|效果图|插画|壁纸|封面|logo|标志|头像|照片|宣传图|主视觉|image|picture|poster|illustration|wallpaper|cover|photo/
  const editUploadedImage = hasUploads && /修改|编辑|替换|移除|删除|擦除|重绘|改成|edit|replace|remove|redraw/.test(text)
  return (creationVerb.test(text) && visualObject.test(text)) || editUploadedImage
}

export function isConversationRequest(value, hasUploads = false) {
  const text = String(value || '').trim().toLowerCase()
  if (!text || isImageGenerationRequest(text, hasUploads)) return false
  const socialOrIdentity = /^(?:你好|您好|嗨|哈喽|hello|hi|hey|你是谁|你叫什么|介绍一下你自己|你能做什么|谢谢|感谢|再见)[呀啊吗呢哇哦呐吧！!。.?？]*$/
  const question = /[?？]\s*$|^(?:请问|谁|什么|为什么|为何|怎么|怎样|如何|是否|能否|可否|可以|有没有|有何|多少|哪(?:个|些|里|种|款))/
  const textTask = /^(?:请|帮我|请帮我)?(?:介绍|解释|说明|告诉|回答|分析|评价|总结|归纳|整理|翻译|改写|润色|写|列出|推荐|比较|对比|检查|计算|聊聊|说说)/
  return socialOrIdentity.test(text) || question.test(text) || textTask.test(text)
}
